import React, { useState, useEffect } from 'react';
import axios from 'axios';
import '../../styles/Admin/Account.css';

const Account = () => {
  const [profile, setProfile] = useState({
    name: '',
    email: '',
    phone: '',
    profilePicture: ''
  });

  const [password, setPassword] = useState({
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  });

  const userId = 'USER_ID'; // Replace with actual user ID

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await axios.get(`/api/account/${userId}`);
        setProfile(res.data);
      } catch (error) {
        console.error('Error fetching profile:', error);
      }
    };

    fetchProfile();
  }, [userId]);

  const handleProfileChange = (e) => {
    setProfile({
      ...profile,
      [e.target.name]: e.target.value
    });
  };

  const handlePasswordChange = (e) => {
    setPassword({
      ...password,
      [e.target.name]: e.target.value
    });
  };

  const handleProfileSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.put(`/api/account/${userId}`, profile);
      setProfile(res.data);
      alert('Profile updated successfully');
    } catch (error) {
      console.error('Error updating profile:', error);
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (password.newPassword !== password.confirmNewPassword) {
      alert('New password and confirm password do not match');
      return;
    }
    try {
      await axios.put(`/api/account/${userId}/password`, {
        currentPassword: password.currentPassword,
        newPassword: password.newPassword
      });
      alert('Password updated successfully');
    } catch (error) {
      console.error('Error updating password:', error);
      alert('Current password is incorrect');
    }
  };

  return (
    <div className="account-settings">
      <h1>Account Settings</h1>
      <div className="account-section">
        <h2>Profile Information</h2>
        <form onSubmit={handleProfileSubmit}>
          <div className="form-group">
            <label>Name</label>
            <input type="text" name="name" value={profile.name} onChange={handleProfileChange} required />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={profile.email} onChange={handleProfileChange} required />
          </div>
          <div className="form-group">
            <label>Phone</label>
            <input type="text" name="phone" value={profile.phone} onChange={handleProfileChange} required />
          </div>
          <button type="submit" className="button-primary">Update Profile</button>
        </form>
      </div>
      <div className="account-section">
        <h2>Change Password</h2>
        <form onSubmit={handlePasswordSubmit}>
          <div className="form-group">
            <label>Current Password</label>
            <input type="password" name="currentPassword" value={password.currentPassword} onChange={handlePasswordChange} required />
          </div>
          <div className="form-group">
            <label>New Password</label>
            <input type="password" name="newPassword" value={password.newPassword} onChange={handlePasswordChange} required />
          </div>
          <div className="form-group">
            <label>Confirm New Password</label>
            <input type="password" name="confirmNewPassword" value={password.confirmNewPassword} onChange={handlePasswordChange} required />
          </div>
          <button type="submit" className="button-primary">Change Password</button>
        </form>
      </div>
    </div>
  );
};

export default Account;
